import BasePopper from "./BasePopper.vue";

export * from "./BasePopper.vue";
export default BasePopper;
